import { csvColumnIndexes } from "./csv";

export const CSV_FIELDS = [
  {
    "key": "name",
    "aliases": [
      "Name",
      "First Name",
      "Ad"
    ],
    "label": [
      "Ad",
      "Name"
    ]
  },
  {
    "key": "surname",
    "aliases": [
      "Surname",
      "Last Name",
      "Soyad"
    ],
    "label": [
      "Soyad",
      "Surname"
    ]
  },
  {
    "key": "email",
    "aliases": [
      "Email",
      "E-mail",
      "Eposta",
      "E-posta"
    ],
    "label": [
      "E-posta",
      "Email"
    ]
  },
  {
    "key": "institution",
    "aliases": [
      "University/Institution",
      "University",
      "Institution",
      "School",
      "Üniversite/Kurum",
      "Üniversite / Kurum"
    ],
    "label": [
      "Üniversite / Kurum",
      "University / Institution"
    ]
  },
  {
    "key": "programme",
    "aliases": [
      "Programme",
      "Program",
      "Bölüm"
    ],
    "label": [
      "Program",
      "Programme"
    ]
  },
  {
    "key": "status",
    "aliases": [
      "Type / RSVP",
      "RSVP",
      "Status",
      "Type",
      "Yanıt",
      "Yanit"
    ],
    "label": [
      "RSVP durumu",
      "RSVP status"
    ]
  },
  {
    "key": "dietary",
    "aliases": [
      "Dietary",
      "Diatery",
      "Dietary Requirements",
      "Beslenme"
    ],
    "label": [
      "Beslenme",
      "Dietary"
    ]
  },
  {
    "key": "rsvpNote",
    "aliases": [
      "RSVP Note",
      "RSVP Notes",
      "Yanıt Notu",
      "Yanit Notu"
    ],
    "label": [
      "RSVP notu",
      "RSVP note"
    ]
  },
  {
    "key": "crmNotes",
    "aliases": [
      "Notes / CRM",
      "Notes/CRM",
      "CRM Notes",
      "Notes",
      "Notlar"
    ],
    "label": [
      "CRM notları",
      "CRM notes"
    ]
  },
  {
    "key": "additionalGuests",
    "aliases": [
      "Additional Guests",
      "Extra Guests",
      "Ek Misafir"
    ],
    "label": [
      "Ek misafir",
      "Additional guests"
    ]
  },
  {
    "key": "active",
    "aliases": [
      "Active",
      "Aktif"
    ],
    "label": [
      "Aktif",
      "Active"
    ]
  }
] as const;

export type CsvField = typeof CSV_FIELDS[number]["key"];
export type CsvMapping = Record<CsvField, number | null>;

export function suggestCsvMapping(headers: string[]): CsvMapping {
  return Object.fromEntries(CSV_FIELDS.map(({ key, aliases }) => {
    const matches = csvColumnIndexes(headers, [...aliases]);
    return [key, matches.length === 1 ? matches[0] : null];
  })) as CsvMapping;
}

export function mappedCsvColumns(headers: string[], mapping?: unknown): Record<CsvField, number[]> {
  if (mapping === undefined) return Object.fromEntries(CSV_FIELDS.map(({ key, aliases }) => [key, csvColumnIndexes(headers, [...aliases])])) as Record<CsvField, number[]>;
  if (!mapping || typeof mapping !== "object" || Array.isArray(mapping)) throw new Error("Invalid CSV column mapping.");
  const input = mapping as Record<string, unknown>;
  const used = new Set<number>();
  const result = {} as Record<CsvField, number[]>;
  for (const { key } of CSV_FIELDS) {
    const index = input[key];
    if (index === null || index === undefined) { result[key] = []; continue; }
    if (typeof index !== "number" || !Number.isInteger(index) || index < 0 || index >= headers.length || used.has(index)) throw new Error("Select a different valid CSV column for each field.");
    used.add(index);
    result[key] = [index];
  }
  if (!result.name.length || !result.email.length) throw new Error("Map both Name and Email before importing.");
  return result;
}
